"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tab = _interopRequireDefault(require("./tab.shape"));

var _tab2 = _interopRequireDefault(require("./tab/tab"));

const TabSelector = props => {
  const {
    tabs,
    selectedTab,
    onChange,
    className,
    children
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('tab-selector', className)
  }, tabs.map(tab => {
    const {
      value,
      title
    } = tab;
    return /*#__PURE__*/_react.default.createElement(_tab2.default, {
      title: title,
      isSelected: value === selectedTab,
      onClick: () => onChange(value),
      key: value
    });
  }), children);
};

TabSelector.propTypes = {
  tabs: _propTypes.default.arrayOf(_tab.default).isRequired,
  selectedTab: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
TabSelector.defaultProps = {
  selectedTab: null,
  className: '',
  children: null
};
var _default = TabSelector;
exports.default = _default;